<template>
  <div>
    <CCard class="bg-style2">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6"> <CIcon class="mr-2" v-if="icon" :name="icon"/> {{ caption }} </span>
      </CCardHeader>
      <CCardBody  class=" pb-0">
        <CRow>
          <CCol>
            <CRow class="mb-3">
              <CCol>
                <label >สถานะ</label>
                <Multiselect class="os"
                             v-model="select.campus"
                             :options="options.campus"
                             label="label"
                             track-by="label"
                             :multiple="false"
                             :search="true"
                >
                </Multiselect>
              </CCol>
            </CRow>
          </CCol>
          <CCol>
            <CRow class="mb-3">
              <CCol>
                <label>ประเภท</label>
                <Multiselect class="os"
                             v-model="select.campus"
                             :options="options.campus"
                             label="label"
                             track-by="label"
                             :multiple="false"
                             :search="true"
                >
                </Multiselect>
              </CCol>

            </CRow>
          </CCol>
          <CCol>
            <CRow class="mb-3">
              <CCol >
                <label >ความเร่งด่วน</label>
                <Multiselect class="os"
                             v-model="select.campus"
                             :options="options.campus"
                             label="label"
                             track-by="label"
                             :multiple="false"
                             :search="true"
                >
                </Multiselect>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'FilterOptions',
  components: {Multiselect},
  props: {
    icon: {
      type: String,
      default: 'cil-magnifying-glass'
    },
    caption: {
      type: String,
      default: 'ตัวกรอง'
    },
    application: {
      type: String,
      default: '0'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    loading:{
      type: Boolean,
      default() {
        return false
      }
    },

  },
  data() {
    return {

      options: {
        campus: [],
        facultys: [],
      },


      select: {
        campus:"",
        facultys:""
      },
    }
  },

  mounted() {

  },

  created() {
    this.onInit();
  },

  beforeDestroy() {

  },

  methods: {
    onInit() {

    },
  },

  computed: {
    ...mapGetters({
    })
  },

  watch: {
    lang: function (value) {

    },


  }
}

</script>
